import axios from "../../axios";

import { UserSearch } from "../types/users.types";
import { getUsersFormatter } from "../formatters/users.formatter";

export const searchUsers = async (params: UserSearch.Request): Promise<UserSearch.Response> => {
  try {
    const queryParams = getUsersFormatter(params);
    const response = await axios.get(`/search/v1/users${queryParams}`);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch users: ${error}`);
  }
};
